import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivateDirective } from '../components/component-can-deactivate';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivateDirective> {
  canDeactivate(component: ComponentCanDeactivateDirective): boolean | Observable<boolean> {
    return !!component ? component.canDeactivate() : true;
  }
}
